// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fog-night"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.49903 14C3.49903 14 3.20173 13.2715 3.13507 13.0227C1.8486 8.22151 4.69784 3.28648 9.49903 2C9.14617 3.31269 9.19128 4.71513 9.56838 6.12252C10.7119 10.3903 15.0986 12.9229 19.3663 11.7794C19.8747 11.6432 20.3585 11.4609 20.8143 11.2383C20.7618 12.1057 20.499 13 19.999 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 18H7M3 22H14M18 22H21M11 18H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FogNightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fog-night',
    ref,
    icon: element,
  },
));

FogNightIcon.displayName = 'FogNightIcon';

export default FogNightIcon;
